export default __webpack_public_path__ + "static/media/export_news.1f5de45e.png";